import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid } from '../cacheUtils';

export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().accounts;
    if (isCacheValid(state.lastFetched)) {
      return { data: state.data, cached: true };
    }
    try {
      const response = await Axios.get('/api/account');
      return { data: response.data.data, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch accounts');
    }
  }
);

const accountsSlice = createSlice({
  name: 'accounts',
  initialState: {
    data: null,
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        if (!state.data) state.loading = true;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        if (!action.payload.cached) {
          state.data = action.payload.data;
          state.lastFetched = Date.now();
        }
        state.loading = false;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateAccountsCache } = accountsSlice.actions;
export default accountsSlice.reducer;